import { CustomerRepoImpl } from "domain/repository/Company/CustomerRepoImpl";
import { CustomerEnquiryRepoImpl } from "domain/repository/CustomerEnquiry/CustomerEnquiryRepoImpl";
import { ExchangeRateRefDateMappingRepoImpl } from "domain/repository/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingRepoImpl";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import { ExchangeRateRefDateMappingVM } from "presentation/viewModel/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingVM";
import { useMemo } from "react";

export const useExchangeRateRefDateMappingVM = () => {
    const [, setExchangeRateRefDateMappingState] = useExchangeRateRefDateMappingTracked();
    const exchangeRateRefDateMappingVM = useMemo(() =>
        ExchangeRateRefDateMappingVM({
            dispatch: [setExchangeRateRefDateMappingState],
            exchangeRateRefDateMappingRepo: ExchangeRateRefDateMappingRepoImpl(),
            customerEnquiryRepo: CustomerEnquiryRepoImpl(),
            customerRepo: CustomerRepoImpl(),
        }), [setExchangeRateRefDateMappingState])

    return exchangeRateRefDateMappingVM
}